import useCurrency from "./currency";

export function useTaxExclusiveMode(currency?: string): boolean {
  const hookCurrency = useCurrency();

  return (currency || hookCurrency) === "USD";
}
